<template>
  <div class="shows">
    <h1>Shows</h1>

    <table>
      <thead>
        <th>Name</th>
      </thead>
      <tbody>
        <tr v-for="show in shows" :key="show.name">
          <td @click="$router.push('/shows/' + show.name)">{{show.name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import config from '../config';

const token =  localStorage.getItem('token');

export default {
  name: 'Shows',
  data() {
    return {
      shows: []
    }
  },
  methods: {
    getShows() {
      this.axios.get(config.api + '/shows', {
        headers: {
          'authorization': token
        }
      })
        .then(result => {
          this.shows = result.data;
        })
    }
  },
  created() {
    this.getShows();
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Shows.vue